import http from './http'
import { useDirtyStore } from '../../../store/dirty.js'

export default class Form {
    constructor(formElement) {
        this.form = formElement
        this.submitButtons = this.form.querySelectorAll('[type="submit"]')
    }

    static find(el) {
        return new Form(this.findElement(el))
    }

    init() {
        // Set dirty on input change
        this.form.querySelectorAll('input, select, textarea').forEach((el) =>
            el.addEventListener('change', () => {
                this.setDirty(true)
            }),
        )

        // On submit
        return new Promise((resolve, reject) => {
            this.form.addEventListener('submit', async (event) => {
                // Setup
                event.preventDefault()

                // Set loading state
                this.loading()

                // Collect form data
                const formData = new FormData(this.form)

                // Validate input
                //

                // Send to server
                await http
                    .post(this.form.action, formData, this.config)
                    .then((res) => {
                        resolve({ data: res.data, res: res, form: this })
                        this.setDirty(false)
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => {
                        this.notLoading()
                    })
            })
        })
    }

    loading() {
        this.submitButtons.forEach((el) => el.classList.add('is-loading'))
    }

    notLoading() {
        this.submitButtons.forEach((el) => el.classList.remove('is-loading'))
    }

    setDirty(val = true) {
        const dirtyStore = useDirtyStore()
        dirtyStore.setIsDirty(val)
    }

    static findElement(mixed) {
        if (mixed instanceof Element) {
            return mixed
        }

        if (typeof mixed === 'string') {
            return document.querySelector(mixed)
        }

        throw new Error('formElement is not of type: selector or Element')
    }
}
